
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/powerstream-cooperation",
      function () {
        return require("private-next-pages/powerstream-cooperation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/powerstream-cooperation"])
      });
    }
  